export function isEventApiUrl(url: URL): boolean {
  return /^\/(?:api\/)?events(?:\/|$)/.test(url.pathname);
}

export function isEventAuthorizationCheck(url: URL): boolean {
  return /^\/(?:api\/)?auth\/me$/.test(url.pathname) && url.searchParams.has('eventSync');
}

export async function purgeEventResponseCaches(storage: CacheStorage = caches): Promise<void> {
  for (const name of await storage.keys()) {
    const cache = await storage.open(name);
    for (const request of await cache.keys()) {
      const url = new URL(request.url);
      if (!isEventApiUrl(url) && !isEventAuthorizationCheck(url)) continue;
      const shell = name === 'meridian-shell' ? await cache.match(request) : undefined;
      if (shell?.headers.get('content-type')?.includes('text/html')) continue;
      await cache.delete(request);
    }
  }
}
